module.exports = __webpack_public_path__ + "static/media/034-copy.d7902ceb.svg";